import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GoogleAnalyticsService {
  private initialized = false;

  init(measurementId: string): void {
    if (this.initialized) return;
    this.initialized = true;

    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      (window as any).dataLayer = (window as any).dataLayer || [];
      function gtag(...args: any[]) {
        (window as any).dataLayer.push(args);
      }
      (window as any).gtag = gtag;

      gtag('js', new Date());
      gtag('config', measurementId);
    };
  }
}
